enum ApiRequestType {
  DELETE,
  GET,
  POST,
  PUT,
}

export default ApiRequestType;
